<template>
  <div>
    <div class="seth-set bg-primary">
      <div class="absolute top-0 mt-2 px-6 py-10">
        <p
          class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
        >
          <feather-icon
            class="flex"
            icon="ArrowLeftIcon"
            svgClasses="w-6 h-6"
            @click="handleBack"
          />
          Go Back
        </p>
      </div>
    </div>
    <div class="flex fixed-top justify-center w-full logsdefine">
      <div class="shadow mt-8 bg-white rounded20 w-6/12 pb-12 px-32 mx-auto">
        <div class="flex justify-center">
          <img
            class="w-32 object-contain h-32"
            src="@/assets/images/logo-bs.png"
            alt="ba"
          />
        </div>
        <div class="text-center">
          <h1 class="lg:text-3xl md:text-2xl text-xl text-dark font-semibold">
            Create your free Account
          </h1>
          <p
            class="lg:text-lg md:text-lg text-sm text-gray justify-center flex"
          >
            Time to get your idea BR<span class="col-y">AI</span>NED
          </p>
        </div>
        <div class="mt-5">
          <div class="relative">
            <div class=" ">
              <h2 class="fsize10 bg-white text-dark font-semibold">
                Full Name
              </h2>
            </div>

            <el-input
              placeholder="Full Name"
              class="rounded-xl mt-3"
              v-model="name"
              name="name"
              v-validate="'required|min:2'"
              data-vv-validate-on="input|blur"
            />

            <span class="text-danger fsize10">
              {{ errors.first("name") }}
            </span>
          </div>
          <div class="relative mt-2">
            <div class="">
              <small class="fsize10 bg-white text-dark font-semibold"
                >Email ID</small
              >
            </div>
            <el-input
              placeholder="Email Id"
              class="rounded-xl mt-2"
              v-model="email"
              type="email"
              name="email"
              v-validate="'required|email|min:2'"
              @change="checkUserInMaster"
            />
            <span
              id="emailError"
              v-if="!errors.first('email')"
              class="fsize10"
              :class="{
                'text-success': emailAvailability.status,
                'text-danger': !emailAvailability.status,
              }"
            >
              {{ emailAvailability.text }}
            </span>
            <div>
              <span class="text-danger fsize10">
                {{ errors.first("email") }}
              </span>
            </div>
            <div>
              <div class="relative mt-4">
                <h2 class="fsize10 bg-white text-dark font-semibold">
                  Phone Number
                </h2>
                <vue-tel-input
                  :disabledFormatting="true"
                  :enabledCountryCode="true"
                  placeholder="Enter phone no"
                  name="Contact no"
                  :required="true"
                  defaultCountry="IN"
                  :autoDefaultCountry="true"
                  v-model="number"
                  class="w-full mt-2 h-12 rounded-xl div-autowidth"
                  v-validate="'required|numeric'"
                  data-vv-validate-on="input|blur"
                  @input="checkNumber"
                  @country-changed="getCountry"
                ></vue-tel-input>
                <span
                  class="fsize10"
                  :class="{
                    'text-success': numberAvailability.status,
                    'text-danger': !numberAvailability.status,
                  }"
                >
                  {{ numberAvailability.text }}
                </span>
                <span class="text-danger fsize10">
                  {{ errors.first("Contact no") }}
                </span>

                <div class="mt-5">
                  <!-- <el-checkbox v-model="terms">Yes, I accept the</el-checkbox>
              <router-link :to="{ name: 'brainedTerms' }" target="_blank">
                <a class="underline cursor-pointer">
                  terms & conditions</a
                ></router-link
              > -->
                </div>
                <!-- <div class="mt-2">
                <el-checkbox v-model="whatsapp"
                  >Yes, I would like to receive updates via
                  Whatsapp</el-checkbox
                >
              </div> -->
              </div>
            </div>
            <div class="mt-8">
              <vs-button
                color="primary"
                type="filled"
                :disabled="isInvalid"
                class="w-full font-semibold sm-fsize14 fsize16 rounded-lg"
                @click="handleClick"
              >
                Next
              </vs-button>
            </div>
          </div>
          <!-- <div class="text-center mt-6">
          <p class="fsize14 text-gray gap-2 font-semibold justify-center flex">
            Already have an account
            <span class="text-primary cursor-pointer">login</span>
          </p>
        </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import VueTelInput from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";
import axios from "axios";
import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "",
      number: "",
      email: "",
      url: process.env.VUE_APP_BRAINED_API_URL,
      //   terms: false,
      whatsapp: false,
      numberAvailability: {},
      emailAvailability: {},
      status: false,
      isInvalid: true,
      code: "",
      iso2: "",
      dialCode: "",
    };
  },
  components: {
    VueTelInput,
  },
  methods: {
    getCountry(country) {
      this.code = country;
    },
    async handleClick() {
      if (
        !this.errors.any() &&
        this.emailAvailability.status &&
        this.numberAvailability.status &&
        this.name
      ) {
        // const reseller = await this.checkResellerLead();
        // console.log(reseller, "RES");
        // if (reseller.length) {
        //   this.checkResellerOffer(reseller[0].Phone);
        // } else {

        // }
        await this.crmLead();
        this.registerUser();
        this.$store.commit("scope/ENTERED_NAME", this.name);
        this.$store.commit("scope/ENTERED_NUMBER", this.number);
        this.$store.commit("scope/ENTERED_EMAIL", this.email);
      } else {
        this.isInvalid = true;
      }
    },
    registerUser() {
      const payload = {
        userData: {
          name: this.name,
          mobile: this.number,
          email: this.email.toLowerCase(),
          dob: null,
          gender: null,
          password: this.password ? this.password : "CeraDefault1",
          confirmPassword: this.password ? this.password : "CeraDefault1",
          source: "Website",
        },
      };
      return new Promise(async (resolve, reject) => {
        try {
          this.$vs.loading();

          const userData = {
            email: this.email.toLowerCase(),

            name: this.name,
            mobile: this.number,
            password: this.password ? this.password : "CeraDefault1",
            collisionUser:
              this.$router.history.current.name === "collision-page"
                ? true
                : false,
            iso2: this.code.iso2,
            dialCode: this.code.dialCode,
          };

          const { data } = await axios.post(
            `${this.url}brained/user/add_user`,
            userData
          );

          if (data.ResponseCode == 100) {
            localStorage.setItem("token", data.token);
            this.$store.commit("scope/SET_TOKEN", data.token);
            const data1 = await axios.post(`${this.url}brained/user/viewUser`, {
              email: this.email.toLowerCase(),
            });
            const userD = {
              ...data1.data.result.projects[0],
              ...data1.data.result,
            };
            this.$store.commit("scope/SET_USER_DETAILS", userD);
            resolve(payload);
            this.$vs.loading.close();
            this.$router.push({ name: "scope-Requirements" });
          } else {
            this.$vs.notify({
              title: "Error",
              text: data.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        } catch (error) {
          this.$vs.loading.close();
          this.$vs.notify({
            title: "Error",
            text: "Oops, something went wrong!",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
          reject(error);
        }
      });
    },
    async crmLead() {
      let leadData = {
        data: [
          {
            URL: this.$route.path,
            Last_Name: this.name,
            Mobile: this.number,
            First_Name: "-",
            Lead_Status: "Not Contacted",
            Whatsapp_Concent: this.whatsapp,
            Email: this.email.toLowerCase(),
          },
        ],
      };
      let crm = {
        leadData: leadData,
      };
      console.log(crm, "crm");
      await axios.post(`${this.url}brained/crm/create_lead`, crm);
    },
    async checkResellerOffer(mobile) {
      const { data } = await this.$store.dispatch("scope/getResellerOffer", {
        number: `91${mobile}`,
      });
      if (data.data.state) {
        this.$store.commit("scope/SET_RESELLER_OFFER", data.data.state);
      } else {
        this.$store.commit("scope/SET_RESELLER_OFFER", false);
        const { data } = await this.$store.dispatch(
          "scope/getResellerLeadOffer",
          { phone: this.number }
        );
        console.log(data.data, "LEAD");
        if (data.data.state) {
          this.$store.commit("scope/SET_RESELLER_OFFER", data.data.state);
        } else {
          this.$store.commit("scope/SET_RESELLER_OFFER", false);
        }
      }
    },
    async checkResellerLead() {
      const { data } = await axios.post(
        `${this.url}brained/crm/checkResellerLead`,
        {
          number: this.number,
        }
      );
      if (data) {
        this.$store.commit("scope/SET_RESELLER_LEAD", true);
        return data.data;
      } else {
        this.$store.commit("scope/SET_RESELLER_LEAD", false);
        return [];
      }
    },
    checkNumber() {
      if (this.number.length >= 6) {
        this.checkNumberApi();
        this.checkValidate();
      } else if (this.number.length == 0) {
        this.numberAvailability = {};
      }
    },
    async checkNumberApi() {
      const { data } = await axios.post(
        `${this.url}brained/user/findUserNumber`,
        {
          mobile: this.number,
          countryCode: {
            dialCode: this.code.dialCode,
            iso2: this.code.iso2,
          },
        }
      );
      console.log(data, "123234345");
      if (data.length > 0) {
        this.numberAvailability = {
          status: false,
          text: "That mobile number already exists. Try another.",
        };
      } else if (this.number.length) {
        this.numberAvailability = {
          status: true,
          text: "Mobile Number is available",
        };
      }
      this.checkValidate();
    },
    async checkUserInMaster() {
      const emailCheck = {
        email: this.email.toLowerCase(),
      };

      const { data } = await axios.post(
        `${this.url}brained/user/checkUserInMaster`,
        emailCheck
      );
      if (data.success) {
        this.emailAvailability = {
          status: true,
          text: "Email is Available",
        };
      } else {
        this.emailAvailability = {
          status: false,
          text: "That email already exists. Please login.",
        };
      }
      this.checkValidate();
    },
    checkValidate() {
      if (
        !this.errors.any() &&
        this.emailAvailability.status &&
        this.numberAvailability.status &&
        this.name
      ) {
        this.isInvalid = false;
      } else {
        this.isInvalid = true;
      }
    },
  },
  watch: {
    name() {
      this.checkValidate();
    },
    code(newVal) {
      console.log(newVal, "newVal");
      this.checkNumber();
    },
  },
  // mounted() {
  //   this.name = this.enteredName;
  //   this.number = this.enteredNumber;
  //   this.email = this.enteredEmail;
  // },
  computed: {},
};
</script>
<style>
.my-height {
  height: 42px !important;
}
.content-hei {
  height: 85vh !important;
}
.col-ed {
  background: #ededed !important;
}
.bg-pink-opacity {
  background: rgba(205, 49, 151, 0.24) !important;
}
.text-headert {
  font-size: 24 px !important;
}
.margin-return {
  margin-top: -20% !important;
}
.col-y {
  color: #ffc90b;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  border-color: hsl(120, 100%, 25%) !important;
  background-color: green;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266 !important;
}
</style>
